var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="avatar-uploader">\n    ';
 var wrapper = customWrapper(avatar); if(wrapper){ 
__p+='\n        '+
((__t=( wrapper ))==null?'':__t)+
'\n    ';
 }else{ 
__p+='\n        <img src="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'"/>\n    ';
 } 
__p+='\n\n    <div class="avatar-uploader__edit">\n        <button type="button" class="btn--secondary qa-button-avatar-edit">'+
((__t=( labels.edit_button ))==null?'':_.escape(__t))+
'<div class="loader"></div></button>\n        ';
 if(!isDefaultAvatar) { 
__p+='\n          <a class="btn--cancel avatar-delete qa-link-avatar-delete" href="#">'+
((__t=( labels.remove_link ))==null?'':_.escape(__t))+
'</a>\n        ';
 } 
__p+='\n    </div>\n\n    <div class="is-hidden">\n        <div id="modal_crop" class="qa-modal-avatar-crop">\n\n            <div class="modal-crop__top qa-modal-avatar-top">\n              <div class="cropper-mask" style="width: '+
((__t=( parseInt(width)+parseInt(margin) ))==null?'':_.escape(__t))+
'px; height: '+
((__t=( parseInt(height)+parseInt(margin) ))==null?'':_.escape(__t))+
'px;">\n                <div class="cropper-container" style="width: '+
((__t=( parseInt(width)+parseInt(margin) ))==null?'':_.escape(__t))+
'px; height: '+
((__t=( parseInt(height)+parseInt(margin) ))==null?'':_.escape(__t))+
'px;">\n                    <img src="'+
((__t=( avatar ))==null?'':_.escape(__t))+
'"/>\n                </div>\n              </div>\n\n              <div class="cropper-zoom qa-modal-avatar-cropper">\n                  <span class="icon--minus icon qa-avatar-crop-zoomout"></span>\n                  <div class="js-slider"></div>\n                  <span class="icon--plus icon qa-avatar-crop-zoomin"></span>\n              </div>\n\n            </div>\n\n            <div class="modal-crop__bottom qa-modal-avatar-bottom">\n                <button class="btn--cta save-avatar-crop js-save-crop qa-button-avatar-upload">'+
((__t=( labels.upload_button ))==null?'':_.escape(__t))+
'<div class="loader"></div></button>\n                <button class="btn--cancel js-cancel-crop qa-link-avatar-cancel">'+
((__t=( labels.cancel_link ))==null?'':_.escape(__t))+
'</button>\n            </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};
